// LIB
import { moduleConfig } from '../../lib/config/appConstants';
import { getUserPermissibleStateCodes } from '../../lib/AuthHelper';
// ACTIONS
import {
  NAVIGATE_TO_EB,
  NAVIGATE_TO_EB_BROKER_SEARCH,
  NAVIGATE_TO_PC,
} from '../actions/ModuleStateActions';
import { USER_PREFERENCE_FETCHED } from '../actions/UserPreferenceActions';

const getInitialState = () => {
  return {
    errorFetchingUserPreference: false,
    isFetchingUserPreference: false,
    module: moduleConfig.PC.shortName,
    userPreference: null,
    userPermissableStateCodes:
      getUserPermissibleStateCodes(moduleConfig.PC.userInfoProductCode) || [],
  };
};

function ModuleState(state = getInitialState(), action) {
  switch (action.type) {
    case NAVIGATE_TO_EB:
      return {
        ...state,
        module: moduleConfig.EB.shortName,
        userPermissableStateCodes: getUserPermissibleStateCodes(
          moduleConfig.EB.userInfoProductCode
        ),
        userPreference: null,
      };
    case NAVIGATE_TO_EB_BROKER_SEARCH:
      return {
        ...state,
        module: moduleConfig.EB_BROKER_SEARCH.shortName,
        userPermissableStateCodes: getUserPermissibleStateCodes(
          moduleConfig.EB.userInfoProductCode
        ),
        userPreference: null,
      };
    case NAVIGATE_TO_PC:
      return {
        ...state,
        module: moduleConfig.PC.shortName,
        userPermissableStateCodes: getUserPermissibleStateCodes(
          moduleConfig.PC.userInfoProductCode
        ),
        userPreference: null,
      };
    case USER_PREFERENCE_FETCHED:
      return {
        ...state,
        isFetchingUserPreference: false,
        userPreference: action.userPreference,
      };
    default:
      return state;
  }
}

export default ModuleState;
